"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var constants_1 = require("../../constants");
var PacksBoxComponent = (function () {
    function PacksBoxComponent(packLevelService, localizationService, eventService, progressService) {
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.progressService = progressService;
        this.packsOptions = [];
        this.cheat = 0;
        this.interfaceLocals = {};
        this.RETINA = constants_1.RETINA;
    }
    PacksBoxComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    PacksBoxComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    PacksBoxComponent.prototype.checkForCheating = function ($event) {
        if (($event.charCode === 25 || $event.charCode === 121) && $event.ctrlKey) {
            this.cheat++;
        }
        if (this.cheat >= 3) {
            this.progressService.unlockAllLevels();
            this.renderPacksData();
        }
    };
    PacksBoxComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.renderInterfaceLocals();
        });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.localizationService.interfaceLocals
                .then(function () {
                _this.renderPacksData();
                _this.eventService.fire('getStarsProgress');
            });
        });
    };
    PacksBoxComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
        this.subscriptionProgressSyncEvent.unsubscribe();
    };
    PacksBoxComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        return this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.titleLocked = _this.interfaceLocals['LockedPacksLabel'];
            _this.renderPacksData();
        });
    };
    PacksBoxComponent.prototype.renderPacksData = function () {
        this.packIds = this.packLevelService.packIds;
        this.packs = this.packLevelService.packs;
        var packsOptions = [];
        var index = 0;
        for (var _i = 0, _a = this.packIds; _i < _a.length; _i++) {
            var packId = _a[_i];
            ++index;
            packsOptions.push({
                index: index,
                packId: packId,
                title: this.interfaceLocals[packId],
                isLocked: this.isLocked(packId),
                packEarnedStars: this.packEarnedStars(packId),
                packLimitStars: this.packLimitStars(packId),
                isEarnedStarsBiggerThanLimited: this.packEarnedStars(packId) >= this.packLimitStars(packId),
                image: require("../../assets/images/png/packs1x/" + packId + ".png"),
                imageRetina: require("../../assets/images/png/packs2x/" + packId + ".png"),
                imageGold: require("../../assets/images/png/packs1x-gold/Gold" + packId + ".png"),
                imageGoldRetina: require("../../assets/images/png/packs2x-gold/Gold" + packId + "2x.png")
            });
        }
        this.packsOptions = packsOptions;
    };
    PacksBoxComponent.prototype.isLocked = function (packId) {
        return this.progressService.isPackLocked(packId);
    };
    PacksBoxComponent.prototype.packEarnedStars = function (packId) {
        return this.progressService.starsEarnedWithPackId(packId);
    };
    PacksBoxComponent.prototype.packLimitStars = function (packId) {
        return this.packLevelService.starsCountForPackId(packId);
    };
    return PacksBoxComponent;
}());
__decorate([
    core_1.HostListener('document:keypress', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], PacksBoxComponent.prototype, "checkForCheating", null);
PacksBoxComponent = __decorate([
    core_1.Component({
        selector: 'packs-box-component',
        template: require('./packs-box.component.pug'),
        styles: [require('./packs-box.component.scss')]
    }),
    __metadata("design:paramtypes", [services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.EventService,
        services_1.ProgressService])
], PacksBoxComponent);
exports.PacksBoxComponent = PacksBoxComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/packs-box/packs-box.component.ts
// module id = 251
// module chunks = 0